import { $,Foundation } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'

import PricetariffsSortTabsTpl from '../../templates/pricetariffs/PricetariffsSortTabsTpl.html'

export default InboomaBaseView.extend({

  template : PricetariffsSortTabsTpl,
  el : '#inb-c-main-sort-nav',

  ui : {
    li : 'li.tabs-title:not(.is-active)'
  },

  events : {
    // Deactivated sorting as not required (yet!)
    //'click @ui.li' : '_changeCollectionSort',
  },

  onRender () {
    // https://foundation.zurb.com/sites/docs/sticky.html
    Foundation.Sticky.defaults.marginTop = 0;
    const meSoSticky = new Foundation.Sticky(this.$el);
  },

  _changeCollectionSort (el) {

      el = $(el.currentTarget);
      el.parent().find('.is-active').removeClass('is-active');
      el.addClass('is-active');
      this.collection.setSort(el.attr('data-inb-val'));
    
    return false;
    
  }
});